query checkPixAPicCodeAvailability($code: String!) {
  checkPixAPicCodeAvailability(code: $code)
}
